import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  INotification, Notification,
} from '../../mobx-store/storeInterfaces/notificationInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';

import Spinner from '../../components/Spinner';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import moment from 'moment';

interface IProps {
  notificationStore: INotification;
  countryStore: CountryStore;
  history: any;
}

interface State {
  loadingCountry: boolean;
}

@inject('notificationStore')
@inject('countryStore')
@observer
class Notifications extends Component<IProps, State> {
  sendNotificationButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('notificationsListPageTitle', {
    });
    this.state = {
      loadingCountry: true,
    };
  }

  handleResendNotificationButtonCellClicked = async (index: number, key: string) => {
    if (this.props.notificationStore.notificationsList[index].getAudience() === 'group') {
      SnackBarComponent.getInstance().openSnackbar(
       'You can\'t resend a group notification',
        4000,
        'error'
      )
      return;
    }
    await this.props.notificationStore.resendNotification(this.props.notificationStore.notificationsList[index].getId());
    await this.props.notificationStore.getNotifications(this.props.countryStore.managedCountries);
  };

  handleActiveInActiveButtonCellClicked = async (index: number, key: string) => {
    const notification = this.props.notificationStore.notificationsList[index];
    try {
      console.log('notification', notification);
      if (notification.getIsBatches()) {
        await this.props.notificationStore.toggleNotificationBatchesStatus(notification.getId(), !notification.getIsBatchesCanceled());
      }
      if (notification.getScheduledSendTime()) {
        await this.props.notificationStore.toggleNotificationScheduledStatus(notification.getId(), !notification.getIsScheduledCanceled());
      }
      await this.props.notificationStore.getNotifications(this.props.countryStore.managedCountries);
    } catch (error) {
      SnackBarComponent.getInstance().openSnackbar(
        'You can\'t active/inactive a notification',
        4000,
        'error'
     ); 
    }
  }

  handelSendNotificationButton = () => {
    this.props.history.push('/notifications/new');
  };

  getSendNotificationButton = () => ({
    title: translate('notificationsListSendNotificationButtonTitle', {
    }),
    onAdd: this.handelSendNotificationButton,
  });

  getNotificationsTableHeader = () => [
    {
      title: translate('notificationsListTitleColumnTitle'),
    },
    {
      title: translate('notificationsListBodyColumnTitle'),
    },
    {
      title: translate('notificationsListAudienceColumnTitle'),
    },
    {
      title: translate('notificationsListTypeColumnTitle'),
    },
    {
      title: translate('notificationListCreatedAtColumnTitle'),
    },
    {
      title: translate('notificationsScheduledSendTimeColumnTitle'),
    },
    {
      title: translate('notificationsIsBatchesColumnTitle'),
    },
    {
      title: translate('notificationsListResendColumnTitle'),
    },
    {
      title: translate('notificationsListActiveInActiveColumnTitle'),
    },
  ];

  getNotificationSentStatus = (notification: Notification) => {
    if (notification.getIsBatches()) {
      return notification.getIsBatchesCanceled() ? 'CANCELED' : 'CANCEL';
    }
    if (notification.getScheduledSendTime()) {
      return notification.getIsScheduledCanceled() ? 'CANCELED' : 'CANCEL';
    }
    return '_';
  };

  allowToResendNotification = (index: number) => {
    const notification = this.props.notificationStore.notificationsList[index];
    if (notification.getIsBatches() || notification.getScheduledSendTime()) {
      return true;
    }
    return false;
  }

  notAllowActiveNotification = (index: number) => {
    const notification = this.props.notificationStore.notificationsList[index];
    if (notification.getIsBatches()) {
      return notification.getIsBatchesCanceled();
    }
    return notification.getIsScheduledCanceled();
  }

  getNotificationsTableData = () => this.props.notificationStore.notificationsList
    .map((notification) => {
      const notificationData = {
        id: notification.getId(),
        body: notification.getBody(),
        title: notification.getTitle(),
        audience: notification.getAudience(),
        type: notification.getType(),
        scheduledSendTime: notification.getScheduledSendTime()
          ? moment(notification.getScheduledSendTime()).format('YYYY-MM-DD HH:mm')
          : '_',
        createdAt: moment(notification.getCreatedAt()).format('YYYY-MM-DD HH:mm'),
        notification: 'Resend',
        isBatches: notification.getIsBatches() ? 'Yes': 'No',
        status: this.getNotificationSentStatus(notification),
      };
      return notificationData;
    });

  getNotificationsTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Text',
      key: 'body',
    },
    {
      cellType: 'Text',
      key: 'audience',
    },
    {
      cellType: 'Text',
      key: 'type',
    },
    {
      cellType: 'Text',
      key: 'createdAt',
    },
    {
      cellType: 'Text',
      key: 'scheduledSendTime',
    },
    {
      cellType: 'Text',
      key: 'isBatches',
    },
    {
      cellType: 'Button',
      key: 'notification',
      onClick: this.handleResendNotificationButtonCellClicked,
      disabled: this.allowToResendNotification
    },
    {
      cellType: 'Button',
      key: 'status',
      onClick: this.handleActiveInActiveButtonCellClicked,
      disabled: (index: number) => !this.allowToResendNotification(index) || this.notAllowActiveNotification(index)
    }
  ];

  render() {
    this.sendNotificationButton = this.getSendNotificationButton();
    this.tableHeader = this.getNotificationsTableHeader();
    this.tableData = this.getNotificationsTableData();
    this.tableCellTypes = this.getNotificationsTableCellTypes();
    return (
        this.state.loadingCountry
        ? <Spinner />
        : <div>
          <GeneralTableComponent
            emptyMessage={translate('notificationsListNoNotificationsMessage', {
            })}
            title={this.title}
            tableHeader={this.tableHeader}
            tableData={this.tableData}
            tableCellTypes={this.tableCellTypes}
            addButton={this.sendNotificationButton}
            loadingStatus={[
              this.props.notificationStore.getNotificationRequestStatus,
            ]}
          />
        </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      notificationStore,
    } = this.props;
    await countryStore.getUserManagedCountries();


    this.setState({
      loadingCountry: false,
    });

    notificationStore.getNotifications(countryStore.managedCountries);
  }
}

export default Notifications;
